import React from 'react';
import { Checkbox } from 'ui';
import { EmailSettingsProps } from '../types';
import { CompanyReportFormIds } from '../constants';

const emailReport = 'emailReport';

export const EmailSettingsReport: React.FC<EmailSettingsProps> = (props) => {
  const { companyReportItem, translation, updateItem, resetValidation } = props;

  const onEmailReportChange = (value: number) => {
    const hasErrors = !!props.validation.emailSetting?.messages?.length;
    const someFieldsEmpty = !companyReportItem.textSet || !companyReportItem.textId || !companyReportItem.textDescription;
    const clearFields = !value && (hasErrors || someFieldsEmpty);

    hasErrors && resetValidation(CompanyReportFormIds.emailSetting);

    updateItem({
      emailReport: !!value,
      ...(clearFields && {
        textId: undefined,
        textSet: undefined,
        textDescription: undefined
      })
    });
  };

  return <div className="row">
    <div className="col-lg-6 col-sm-12">
      <Checkbox
        className={undefined}
        componentId={emailReport}
        value={companyReportItem?.emailReport ? 1 : 0}
        label={{ text: translation.email_settings_report_checkbox, visible: true }}
        onChange={onEmailReportChange}
      />
    </div>
  </div>;
};
